export default function(o, movie){

  var lang = o.store('lang')

  var storiesLabel = o.util.getTranslation(o, 'stories')

  var movieTitle = movie[lang]

  var home = function(){
    history.pushState({}, '', '/')
    o.render(o)
  }

  var back = function(){
    history.go(-1)
  }

  var div =
    $('<div>')
    .css({
      textAlign: 'center',
      whiteSpace: 'nowrap',
      overflowY: 'auto',
      '-webkit-overflow-scrolling': 'touch',
      fontSize: o.fontSizeDef.s,
      padding: "0.8rem",
    })
    .append([

      o.component.button(o, 'open memory box', home),

      o.component.spacer(o),

      o.component.button(o, storiesLabel, back),
      
      o.component.spacer(o),

      o.component.button(o, movieTitle),

    ])

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/story/header/header.js